import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/pro-solid-svg-icons/faArrowLeft";
import { faXmark } from "@fortawesome/pro-solid-svg-icons/faXmark";

interface SheetHeaderProps {
  title: string;
  icon?: React.ReactNode;
  onBack?: () => void;
  onClose?: () => void;
  /** Right-side action slot (e.g. "Clear all" button) */
  action?: React.ReactNode;
  /** Tighter padding for peek state */
  compact?: boolean;
  className?: string;
  /** Custom aria-label for back button */
  backLabel?: string;
  /** Custom aria-label for close button */
  closeLabel?: string;
}

export function SheetHeader({
  title,
  icon,
  onBack,
  onClose,
  action,
  compact = false,
  className = "",
  backLabel = "Back",
  closeLabel = "Close",
}: SheetHeaderProps) {
  return (
    <div
      className={`flex items-center gap-2 border-b shrink-0 z-10 ${compact ? "px-3 py-2" : "px-4 py-3"} ${className}`}
    >
      {onBack && (
        <button
          type="button"
          onClick={onBack}
          className="min-w-[44px] min-h-[44px] flex items-center justify-center shrink-0"
          aria-label={backLabel}
        >
          <FontAwesomeIcon icon={faArrowLeft} className="h-5 w-5" />
        </button>
      )}

      {icon && <span className="shrink-0">{icon}</span>}

      <h2 className={`font-semibold flex-1 min-w-0 truncate ${compact ? "text-base" : "text-lg"}`}>
        {title}
      </h2>

      {action && <div className="shrink-0">{action}</div>}

      {onClose && (
        <button
          type="button"
          onClick={onClose}
          className="min-w-[44px] min-h-[44px] flex items-center justify-center shrink-0"
          aria-label={closeLabel}
        >
          <FontAwesomeIcon icon={faXmark} className="h-5 w-5" />
        </button>
      )}
    </div>
  );
}
